import { useCallback, useState } from 'react';

export const HAS_SEEN_MODERATION_ONBOARDING_KEY =
  'mm-groups-moderation-onboardingSeen';

const getOnboardingSeenFromLocalStorage = () => {
  const onboardingSeen = localStorage.getItem(
    HAS_SEEN_MODERATION_ONBOARDING_KEY,
  );
  return onboardingSeen === 'true';
};

const setOnboardingSeenInLocalStorage = () => {
  localStorage.setItem(HAS_SEEN_MODERATION_ONBOARDING_KEY, 'true');
};

export const useHasSeenModerationOnboarding = () => {
  const [hasSeenOnboarding, setHasSeenOnboarding] = useState(() =>
    getOnboardingSeenFromLocalStorage(),
  );

  const toggleHasSeenOnboarding = useCallback(() => {
    setOnboardingSeenInLocalStorage();
    setHasSeenOnboarding(true);
  }, []);

  return [hasSeenOnboarding, toggleHasSeenOnboarding] as const;
};
